import { render, staticRenderFns } from "./SwiperWeb.vue?vue&type=template&id=493403fc&scoped=true&"
import script from "./SwiperWeb.vue?vue&type=script&lang=js&"
export * from "./SwiperWeb.vue?vue&type=script&lang=js&"
import style0 from "./SwiperWeb.vue?vue&type=style&index=0&id=493403fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493403fc",
  null
  
)

export default component.exports